module.exports = __webpack_public_path__ + "static/media/life-inspiring.9635878e.png";